import React, { useContext } from 'react'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import { Box, Button, Illustration } from '@node-space/ui-components'
import { WalletActionContext } from 'pages/Wallets/context/WalletSheetProvider'
import { floorWithPrecision, numberWithCommas } from 'utils/utils'
import { convertFromWalletAtom, convertToWalletAtom, quoteAtom } from './atoms/atoms'

export const ConvertComplete = () => {
  const { t } = useTranslation()
  const [walletAction] = useContext(WalletActionContext)
  const convertFromWallet = useAtomValue(convertFromWalletAtom)
  const convertToWallet = useAtomValue(convertToWalletAtom)
  const quote = useAtomValue(quoteAtom)

  const handleNavigateClick = async () => {
    walletAction?.onClose()
  }

  return (
    <Box flexCol gapY={32} align="center" paddingT={24}>
      <Box flexCol gapY={16} align="center" className="text-center">
        <Illustration name="HandsClapping" color="success" />
        <h1 className="text-foreground-prominent text-h1 max-w-[414px] mx-auto">
          {t('wallets.convert.completeStepHeader', {
            fromCurrency: convertFromWallet?.currency?.code,
            toCurrency: convertToWallet?.currency?.code,
            fromAmount: floorWithPrecision(
              quote.amountIn,
              convertFromWallet?.currency?.pricePrecision
            ),
            toAmount: numberWithCommas(
              floorWithPrecision(quote?.amountOut, convertToWallet?.currency?.pricePrecision)
            ),
          })}
        </h1>
        <p className="text-foreground-prominent text-body-strong max-w-[370px] mx-auto">
          {t('wallets.convert.completeStepDescription')}
        </p>
      </Box>

      <Button data-testid="done" variant="primary" onClick={handleNavigateClick}>
        {t('done')}
      </Button>
    </Box>
  )
}
